<button class="control-btn"
        (click)="selectANewField()"
        id="btndropdown">
    Required Fields
</button>

<div class="dropdownButtons" id="dropdownMenu" #dropdownMenu>
    <button [matTooltip]="isDisable.addresses ? 'Cannot add more than 2' : null" matTooltipPosition="above"
            [ngClass]="isDisable.addresses ? 'btn-disabled' : 'contactButton'" class="contactButton"
            (click)="contactClick(ContactTypes.ADDRESS)">
        <img style="float: left" src='assets/svg/house.svg'>
        Add Address
    </button>

    <button [matTooltip]="isDisable.emails ? 'Cannot add more than 2' : null" matTooltipPosition="above"
            [ngClass]="isDisable.emails ? 'btn-disabled' : 'contactButton'" class="contactButton"
            (click)="contactClick(ContactTypes.EMAIL)">
        <img style="float: left" src="assets/svg/email.svg">
        Add Email
    </button>

    <button [matTooltip]="isDisable.org ? 'Cannot add more than 1' : null" matTooltipPosition="above"
            [ngClass]="isDisable.org ? 'btn-disabled' : 'contactButton'"
            (click)="contactClick(ContactTypes.ORGANISATION)">
        <img style="float: left" src="assets/svg/organisation.svg">
        Add Organisation
    </button>

    <button [matTooltip]="isDisable.phones ? 'Cannot add more than 2' : null" matTooltipPosition="above"
            [ngClass]="isDisable.phones ? 'btn-disabled' : 'contactButton'" class="contactButton"
            (click)="contactClick(ContactTypes.PHONE)">
        <img style="float: left" src="assets/svg/newphone.svg">
        Add Phone Number
    </button>

    <button [matTooltip]="isDisable.urls ? 'Cannot add more than 2' : null" matTooltipPosition="above"
            [ngClass]="isDisable.urls? 'btn-disabled' : 'contactButton'" class="contactButton"
            (click)="contactClick(ContactTypes.URL)">
        <img style="float: left" src="assets/svg/url.svg">
        Add URL
    </button>

    <button [matTooltip]="isDisable.birthdays ? 'Cannot add more than 1' : null" matTooltipPosition="above"
            [ngClass]="isDisable.birthdays ? 'btn-disabled' : 'contactButton'" (click)="contactClick(ContactTypes.BIRTHDAY)">
        <img style="float: left" src="assets/svg/birthday.svg">
        Add Birthday
    </button>
</div>